var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 21.9c-.6 0-1.1-.3-1.3-.9L.4 1l26.4 6.9c.8.2 1.2 1 1 1.7-.2.8-1 1.2-1.7 1L5.3 5.2l6.3 14.7c.3.7 0 1.6-.7 1.9-.2.1-.4.1-.6.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 30.8L.2 14c-.4-.9 0-1.9.9-2.3.9-.4 1.9 0 2.3.9l5.7 12.5 11-10.1c.7-.6 1.8-.6 2.4.1.6.7.6 1.8-.1 2.4L7.8 30.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 30c-.3 0-.6-.1-.8-.4-.4-.5-.4-1.2.1-1.6l14.3-13-16.5-4c-.6-.1-1-.8-.8-1.4.1-.6.8-1 1.4-.8l20.6 5-17.5 15.9c-.2.2-.5.3-.8.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfx);
export default __webpack_public_path__ + "static/media/vfx.3552e4a0f768c74616ae21aab304e49b.svg";
export { ForwardRef as ReactComponent };